<template>
  <div id="timePicker">

    <v-dialog
      persistent
      lazy
      full-width
      width="290px"
    >
      <v-icon class="icon" slot="activator">mdi-clock</v-icon>
      <v-time-picker scrollable color="primary" v-model="timePicker" actions>
        <template slot-scope="{ save, cancel }">
          <!-- <v-card-actions @save="timePickerChanged"> -->
            <v-btn flat color="primary" @click="cancel">Cancel</v-btn>
            <v-btn flat color="primary" @click="timePickerChanged">Save</v-btn>
          </v-card-actions>
        </template>
      </v-time-picker>
    </v-dialog>

    <v-text-field
      :label="label"
      v-model="textField"
      mask="time"
      class="input"
      @change="textFieldChanged"
    ></v-text-field>

    <div @click="amChanged">{{am ? 'AM' : 'PM'}}</div>

  </div>
</template>

<script>
  export default {
    data () {
      return {
        timePicker: null,
        textField: null,
        am: true,
        value: null
      }
    },
    props: {
      dialog: {

      },
      label: {
        default: 'Enter Time'
      },
      initValue: {
        // default: moment().format('HH')
      }
    },
    methods: {

      save () {

      },

      cancel () {
        
      },

      convertFromNumber (num) {
      
      },
      
      amChanged () {
        this.am = !this.am;
      },
      
      textFieldChanged () {

      },
      
      timePickerChanged () {
        
      }
    
    },
    
    created () {
      this.value = this.initValue;
    }
  }
</script>

<style lang="scss" scoped>

  #timePicker {

    .icon {
      float: left;
      width: 50px;
    }

    .input {
      float: left;
      display: inline-block;
      width: calc(100% - 50px);
    } 
  }

</style>



// WEBPACK FOOTER //
// src/components/TimePicker.vue